import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../../classes/user';

@Pipe({
  name: 'userFilter',
  pure: false
})
export class UserFilterPipe implements PipeTransform {

  transform(userList: Array<User>, filterValue: string): any {
    if (!userList || !filterValue) {
      return userList;
    }
    return userList.filter((user: User) => {
      const userActiveString = user.active ? 'sì' : 'no';
      return user.username.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1 ||
        user.role.value.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1 ||
        userActiveString.indexOf(filterValue.toLowerCase()) !== -1;
    });
  }

}
